/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `>` - greater_than
 * * `>=` - greater_than_equal
 * * `<` - less_than
 * * `<=` - less_than_equal
 * @export
 */
export const OperatorEnum = {
  GREATER_THAN: ">",
  GREATER_THAN_EQUAL: ">=",
  LESS_THAN: "<",
  LESS_THAN_EQUAL: "<=",
} as const;
export type OperatorEnum = (typeof OperatorEnum)[keyof typeof OperatorEnum];

export function instanceOfOperatorEnum(value: any): boolean {
  for (const key in OperatorEnum) {
    if (Object.prototype.hasOwnProperty.call(OperatorEnum, key)) {
      if (OperatorEnum[key as keyof typeof OperatorEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function OperatorEnumFromJSON(json: any): OperatorEnum {
  return OperatorEnumFromJSONTyped(json, false);
}

export function OperatorEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): OperatorEnum {
  return json as OperatorEnum;
}

export function OperatorEnumToJSON(value?: OperatorEnum | null): any {
  return value as any;
}

export function OperatorEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): OperatorEnum {
  return value as OperatorEnum;
}
